<template>
  <div class="login" v-scroll="scroll">
    <cookie v-if="lang === 'en'" style="z-index: 2;position: relative;"></cookie>
    <div class="login-wrapper" v-if="requireLogin">
      <div class="login-main" v-if="!loggedIn">
        <img class="czur-logo" src="../assets/images/czur_logo.png" alt="">
        <div class="title">{{$t('index.loginText')}}</div>
        <div class="input-wrap">
          <input class="input-account" type="text" v-model="userName" :placeholder="$t('index.accountNumber')" v-on:keyup.enter="login">
          <input class="input-pwd" type="password" v-model="password" v-on:input="inputOnchange" :placeholder="$t('index.password')" v-on:keyup.enter="login">
          <!-- <div class="verifyMsg" v-if="verifyMsg">{{$t('index.errorTip')}}</div> -->
          <i class="icon-login-btn" @click="login"></i>
          <div class="login-loading" :class="{'show': logining}">
            <div class="container">
              <loading :loading="true"></loading>
            </div>
          </div>
        </div>
        <div class="verifyMsg" :class="{'show': verifyMsg}">{{$t('index.errorTip')}}</div>
        <div class="btns-line">
          <a class="btns register-btn" @click="register">{{$t('index.register')}}</a>
<!--          <a class="btns" @click="findPwd">{{$t('index.forgetPwd')}}</a>-->
          <a class="btns" @click="showPop = true">{{$t('index.forgetPwd')}}</a>
        </div>
        <div class="line"></div>
        <div v-if="thirdLogin" class="third-party">
          <a :href="'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101562028&scope=get_user_info&redirect_uri=https%3a%2f%2fpassport.czur.cc%2fapi%2fv2%2fpublic%2fthirdOAuth%2fcallback%3fadaptor%3dqq_web%26lang%3d' + lang + '%26callback%3d' + pageHref + '&state=' + timeStamp" id="qqBtn">
            <i class="icon-qq"></i>
          </a>
          <a :href="'https://open.weixin.qq.com/connect/qrconnect?appid=wx1d6ec286ebe96e95&redirect_uri=https%3a%2f%2fpassport.czur.cc%2fapi%2fv2%2fpublic%2fthirdOAuth%2fcallback%3fadaptor%3dwechat_web%26lang%3d' + lang + '%26callback%3d' + pageHref + '&response_type=code&scope=snsapi_login&state=' + timeStamp + '#wechat_redirect'" id="weiinBtn">
            <i class="icon-weixin"></i>
          </a>
          <a :href="'https://api.weibo.com/oauth2/authorize?client_id=1207713704&response_type=code&redirect_uri=https%3A%2F%2Fpassport.czur.cc%2Fapi%2Fv2%2Fpublic%2FthirdOAuth%2Fcallback%3fadaptor%3dweibo_web%26lang%3d' + lang + '%26callback%3d' + pageHref" id="weiboBtn">
            <i class="icon-weibo"></i>
          </a>
        </div>
        <div class="login-footer">
          <span class="lang" @click="changeLocale('zh-CN')">简体中文</span>
          <span>|</span>
          <span class="lang" @click="changeLocale('en')">English</span>
          <span>|</span>
          <span class="lang" @click="changeLocale('zh-TW')">繁體中文</span>
          <span>|</span>
          <span class="lang" @click="changeLocale('ru_RU')">Pусский</span>
          <div class="copy-right">
            <a href="https://beian.miit.gov.cn" target="_blank">辽ICP备13011158号-8</a>
          </div>
        </div>
      </div>
      <div class="select-function" :class="{'animate': loggedIn}" v-if="loggedIn">
        <div class="title">{{$t('index.selectFunction')}}</div>
        <div class="select-bottom">
          <div class="select-item-wrap clearfix">
            <div class="select-item select-item-et" @click="goEt">
              <img class="select-item-img" src="../assets/images/select_et.png" alt="">
              <div class="select-item-title">ET</div>
            </div>
            <div class="select-item select-item-notebook" @click="goNotebook">
              <img class="select-item-img" src="../assets/images/select_notebook.png" alt="">
              <div class="select-item-title">{{$t('index.notebook')}}</div>
            </div>
            <!-- <div class="select-item select-item-starry" @click="goStarry">
              <img class="select-item-img" src="../assets/images/select_starry.png" alt="">
              <div class="select-item-title">投影仪</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="login-mark"></div>
      <i class="icon-czur-logo"></i>
    </div>
    <div class="pop" v-if="showPop">
      <div class="pop-box main clearfix">
        <div class="pop-main">
          <div class="pop-main-top">{{$t('findPwd.account_type')}}</div>
          <div class="pop-btn-box">
            <div class="pop-btn" @click="gofindPwd">{{$t('findPwd.starryHub_account')}}</div>
            <div class="pop-btn" @click="findPwd">{{$t('findPwd.czur_cloud_account')}}</div>
          </div>
        </div>
        <i class="icon-close" @click="showPop = false"></i>
      </div>
    </div>
    <div class="pop-country-code" v-if="showCountryInternal">
      <div class="pop-box main clearfix">
        <div class="pop-main">
          <div class="pop-main-top">{{$t('operation.msg')}}</div>
          <div class="pop-content-box">
            <div class="pop-text">{{$t('index.countryError')}}</div>
          </div>
          <div class="pop-btn" @click="goCountryHost">{{$t('index.countryGo')}}</div>
        </div>
        <i class="icon-close" @click="showCountryInternal = false"></i>
      </div>
    </div>
    <!-- 跨域退出账户中心，为了实现单点登录 -->
    <iframe class="logout-frame" v-for="(api,index) in logoutAPIs" v-bind:src="api" v-bind:key="index" frameborder="0"></iframe>
    <!-- 检查登录中心是否已登录 -->
    <iframe class="login-check" v-bind:src="loginCheckUrl" @load="loginCheckLoaded"></iframe>
  </div>
</template>
<script>
import cookie from './cookie.vue'
import * as config from 'common/script/config'
import validate from 'common/script/validate'
import httpClient from 'common/script/http'
import md5 from 'js-md5'
import User from 'common/model/User'
import Loading from './Loading'
export default {
  name: 'login',
  components: {
    Loading,
    cookie
  },
  data () {
    return {
      // requireLogin: false,
      requireLogin: true,
      userName: '',
      password: '',
      nameValidate: {
        invalidate: false
      },
      pwdValidate: {
        invalidate: false
      },
      verifyMsg: false,
      showLoginBtn: false,
      loggedIn: false,
      logoutAPIs: [],
      logining: false,
      loginCheckUrl: config.LOGIN_CHECK + encodeURIComponent(config.APP_HOST + '/v1/loginCheck'),
      lang: '',
      timeStamp: 201905120322,
      pageHref: encodeURIComponent(encodeURIComponent(window.location.href)),
      thirdLogin: config.CHANNEL !== 'US',
      showPop: false,
      showCountryInternal: false,
      countryCode: ''
    }
  },
  created: function () {
    this.lang = validate.lang()
    this.timeStamp = new Date().getTime()
    if (config.getReqParam('action') === 'logout') {
      this.logoutAPIs.push(config.PASSPORT_HOST + '/?action=logout')
      this.withOutLogin()
    } else {
      // 如果URL地址中含有token和u_id
      var token = config.getReqParam('token')
      var uId = config.getReqParam('u_id')
      // console.log(token, uId)
      if (token && uId && token !== '' && uId !== '') {
        config.cookieSet(config.COOKIE_KEY.U_ID, uId)
        config.cookieSet(config.COOKIE_KEY.TOKEN, token)
        window.location.href = '/#/'
      }
      this.getUserInfo()
    }
  },
  mounted () {
    if (this.password !== '') {
      this.showLoginBtn = true
    }
  },
  methods: {
    loginCheckLoaded: function () {
      console.log('login check loaded')
      this.getUserInfo()
    },
    changeLocale: function (lang) {
      this.$i18n.locale = lang
      this.lang = lang
      config.cookieSet('lang', lang)
    },
    scroll: function (event) {
      event = event || window.event
      if (event.preventDefault) {
        // Firefox
        event.preventDefault()
        event.stopPropagation()
      } else {
        // IE
        event.cancelBubble = true
        event.returnValue = false
      }
    },
    withOutLogin: function () {
      this.requireLogin = true
      window.location.href = config.urlRemoveParam(['action'])
    },
    alreadyLogin: function () {
      this.requireLogin = true
      this.loggedIn = true
    },
    inputOnchange: function () {
      this.showLoginBtn = true
    },
    login: function () {
      if (!this.nameCheck() && !this.pwdCheck()) {
        this.logining = true
        this.showLoginBtn = false

        if (validate.isStarryNo(this.userName)) { // Starry投影仪登录
          httpClient.postData(config.STARRY_HOST + '/login', {
            username: this.userName,
            pwd: md5(this.password).toUpperCase()
          }, this).then((response) => {
            console.log(response)
            if (response.code === config.R_CODE.SUCCESS) {
              // 登陆 默认同意cookie
              localStorage.setItem('cookie_necessary', 1)
              localStorage.setItem('cookie_preference', 0)
              localStorage.setItem('cookie_statistics', 0)
              // 保存登录信息
              config.cookieSet(config.COOKIE_KEY.U_ID, response.data.accountNo)
              config.cookieSet(config.COOKIE_KEY.TOKEN, response.data.token)
              config.cookieSet(config.COOKIE_KEY.USER_NAME, response.data.name)
              config.cookieSet(config.COOKIE_KEY.COUNTRY_CODE, response.data.countryCode)
              config.cookieSet(config.COOKIE_KEY.MODE, 'starry')
              if (config.getReqParam('callback')) {
                var callback = decodeURIComponent(config.getReqParam('callback'))
                callback = config.appendParam(callback, 'uid', response.data.accountNo)
                callback = config.appendParam(callback, 'token', response.data.token)
                callback = config.appendParam(callback, 'country', response.data.countryCode)
                callback = config.appendParam(callback, 'lang', this.lang)
                window.location.href = callback
              } else {
                if (config.ENV === 'dev' || config.ENV === 'dev_us') {
                  let url = config.STARRY_WEB
                  url += `?uid=${response.data.accountNo}&token=${response.data.token}&lang=${this.lang}&country=${response.data.countryCode}`
                  window.location.href = url
                } else {
                  window.location.href = window.location.origin + '/starry.html'
                }
              }
            } else if (response.code === config.R_CODE.PWD_ERROR) {
              this.verifyMsg = true
            } else if (response.code === config.R_CODE.INTERNAL_COUNTRY_CODE) {
              this.countryCode = response.data
              this.showCountryInternal = true
            }
            this.logining = false
            this.showLoginBtn = true
          })
        } else { // 成者云账号登录
          httpClient.postData(config.PASSPORT_HOST + config.PASSPORT_API + '/login', {
            username: this.userName,
            password: md5(this.password).toUpperCase()
          }, this).then((response) => {
            if (response.code === config.R_CODE.SUCCESS) {
              let historyUid = config.cookieGet(config.COOKIE_KEY.U_ID)
              // 保存登录信息
              config.cookieSet(config.COOKIE_KEY.U_ID, response.body.id)
              config.cookieSet(config.COOKIE_KEY.TOKEN, response.body.token)
              config.cookieSet(config.COOKIE_KEY.USER_NAME, response.body.name)
              config.cookieSet(config.COOKIE_KEY.MODE, 'cloud')
              this.loggedIn = true
              if (config.getReqParam('callback') && historyUid === response.body.id + '') {
                window.location.href = decodeURIComponent(config.getReqParam('callback'))
              }
            } else if (response.code === config.R_CODE.PWD_ERROR) {
              this.verifyMsg = true
            } else if (response.code === config.R_CODE.USER_INACTIVE) {
              this.$toasted.show(this.$t('index.unactivated'), {
                position: 'top-center'
              })
            }
            this.logining = false
            this.showLoginBtn = true
          })
        }
      }
    },
    register: function () {
      window.location.href = config.PASSPORT_HOST + '/register.html?Channel=' + config.CHANNEL + '&lang=' + validate.lang() + '&service=' + encodeURIComponent('https://' + window.location.host)
    },
    findPwd: function () {
      var url = config.PASSPORT_HOST + '/findPwd.html?Channel=' + config.CHANNEL + '&lang=' + validate.lang()
      window.open(url, '_blank')
    },
    gofindPwd: function () {
      this.$router.push('findPwdAccount')
    },
    goEt: function () {
      this.$router.push('et')
    },
    goNotebook: function () {
      this.$router.push('notebook')
    },
    goStarry: function () {
      window.location.href = config.STARRY_WEB
    },
    nameCheck: function () {
      if (validate.stringEmpty(this.userName)) { // 账号为空
        this.nameValidate.invalidate = true
        this.verifyMsg = true
      } else if (!validate.validateEmail(this.userName) && !validate.isTel(this.userName) && !validate.isStarryNo(this.userName)) { // 账号不为空，但也不是email和电话号码
        this.nameValidate.invalidate = true
        this.verifyMsg = true
      } else { // 账号为email或电话号码
        this.nameValidate.invalidate = false
        this.verifyMsg = false
      }
      return this.verifyMsg && this.nameValidate.invalidate
    },
    pwdCheck: function () {
      this.verifyMsg = false
      if (validate.stringEmpty(this.password)) { // 密码为空
        this.pwdValidate.invalidate = true
        this.verifyMsg = true
      } else {
        this.pwdValidate.invalidate = false
      }
      return this.verifyMsg && this.nameValidate.invalidate
    },
    getUserInfo: function () { // 获取用户信息，可以通过此接口来判断用户是否登录
      const uId = config.cookieGet(config.COOKIE_KEY.U_ID)
      console.log('userId:', uId)
      if (uId) {
        httpClient.getData(config.APP_HOST + '/v1/user/info?u_id=' + uId,
          this).then((response) => {
          if (response.code === config.R_CODE.SUCCESS) {
            var user = new User()
            // console.log(user)
            user.loadJson(response.body)
            // console.log(user)
            // 用户信息
            this.alreadyLogin()
          } else {
            this.withOutLogin()
          }
        })
      } else {
        this.withOutLogin()
      }
    },
    goCountryHost: function () {
      window.location.href = config.OTHER_HOST
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '../common/stylus/const'
$login-height = 100%
body,html
  height 100%
.logout-frame, .login-check
  width 0
  height 0
  overflow hidden
  opacity 0
.login
  width 100%
  min-height 100%
  height $login-height
  background-image url(../assets/images/bg.jpg)
  background-position center
  background-repeat no-repeat
  background-size cover
  position relative
  .pop
    width: 100%
    height: 100%
    position: fixed
    top: 0
    left: 0
    background-color: rgba(0,0,0,0.4)
    z-index: 999
    font-size 12px
    .pop-box
      width: 400px
      height: 160px
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
      margin: auto
      background-color: #fff
      border-radius: 4px
      .icon-close
        position: absolute;
        top: 13px;
        right: 13px;
        color: #999;
        cursor: pointer;
      .pop-main
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        .pop-main-top
          position: absolute;
          width: 100%;
          top: 13px;
          left: 0;
          font-size: 16px;
          line-height: 16px;
          color: #000000;
        .pop-btn-box
          position absolute
          top 67px
          width 100%
          height 70px
          display flex
          flex-direction column
          align-items center
          justify-content space-between
        .pop-btn
          width: 300px
          height: 30px
          line-height 30px
          border-radius: 4px
          background-color #3d3d3d
          color: #ffffff;
          &:hover
            cursor pointer
  .pop-country-code
    width: 100%
    height: 100%
    position: fixed
    top: 0
    left: 0
    background-color: rgba(0,0,0,0.4)
    z-index: 999
    font-size 12px
    .pop-box
      width: 480px
      height: 298px
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
      margin: auto
      background-color: #fff
      .icon-close
        position: absolute;
        top: 20px;
        right: 18px;
        color: #999;
        cursor: pointer;
      .pop-main
        width: 100%;
        height: 100%;
        .pop-main-top
          width: 100%;
          height 56px
          top: 0px;
          left: 0;
          font-size: 24px;
          line-height: 56px;
          color: #3d3d3d;
          background-color #FAFAFA
        .pop-content-box
          width 70%
          height 70px
          margin 56px auto 0
          //display flex
          //flex-direction column
          //align-items center
          //justify-content space-between
          font-size 15px
          color #3d3d3d
          line-height 23px
        .pop-btn
          width: 305px
          height: 45px
          line-height 45px
          border-radius: 4px
          background-color #272F44
          color: #ffffff
          font-size 12px
          position absolute
          bottom 28px
          left 50%
          transform translateX(-50%)
          &:hover
            cursor pointer
  .login-mark
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background-color #272f44
    opacity 0.3
  .icon-czur-logo
    position absolute
    top 35px
    left 40px
    font-size 36px
    color #fff
  .login-main
    width 400px
    height 358px
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    margin auto
    text-align center
    z-index 1
    color #fff
    .title
      font-size 18px
      font-weight 600
      letter-spacing 2px
      margin 14px 0 23px 0
    .input-wrap
      display inline-block
      width 334px
      height 114px
      background-image url(../assets/images/input_bg.png)
      background-repeat no-repeat
      background-position center
      position relative
      padding 17px
      box-sizing border-box
      input
        display block
        width 300px
        height 40px
        padding 0 15px
        box-sizing border-box
        background-color transparent !important
        border none
        outline none
        color #3d3d3d
        font-size 14px
        &:-webkit-autofill
          background-color transparent
          transition background-color 50000s ease-in-out 0s
        &.input-account
          border-bottom 1px solid #e5e5e5
          border-radius 6px 6px 0 0
          /*去掉IE上的叉叉*/
          &::-ms-clear
            display none
        &.input-pwd
          width 280px
          border-radius 0 0 6px 6px
          /*去掉Safari上的钥匙*/
          &::-webkit-credentials-auto-fill-button
            visibility hidden
            display none !important
            pointer-events none
            position absolute
            right 0
            /*去掉IE上的眼睛*/
          &::-ms-reveal
            display none
      .icon-login-btn
        color #3d3d3d
        font-size 26px
        position absolute
        bottom 22px
        right 24px
        cursor pointer
        &:hover
          opacity _opacity
      .login-loading
        position absolute
        display none
        bottom 5px
        right 10px
        width 26px
        height 26px
        &.show
          display block
    .verifyMsg
      color #e36868
      font-size 14px
      opacity 0
      &.show
        opacity 1
    .btns-line
      padding 8px 0 20px 0
      .btns
        color #fff
        font-size 14px
        &.register-btn
          margin-right 60px
        &:hover
          cursor pointer
          opacity _opacity
    .line
      height 2px
      background-image url(../assets/images/line.png)
      background-size 100%
      background-repeat no-repeat
      display none
    .third-party
      padding 29px 0
      a
        margin-right 70px
        cursor pointer
        &:last-child
          margin-right 0
        i
          color #fff
          font-size 28px
          &:hover
            opacity _opacity
    .login-footer
      position fixed
      width 100%
      left 0
      bottom 20px
      font-size 12px
      span
        color #777887
        margin 0 1px
        &.lang
          color #fff
          cursor pointer
      .copy-right
        display block
        width 100%
        padding 20px 0px 0px
        text-align center
        color #fff
        a
          color #fff
  .select-function
    .title
      position absolute
      top 171px
      width 100%
      font-size 60px
      color #fff
      font-weight 600
      letter-spacing 3px
      z-index 1
    .select-bottom
      display flex
      width 100%
      height 0
      justify-content center
      background-color #fff
      position fixed
      left 0
      right 0
      bottom 0
      z-index 1
      padding-top 120px
      box-sizing border-box
      .select-item-wrap
        width 628px
        height 207px
        .select-item
          float left
          width 188px
          cursor pointer
          transition all 0.3s ease-in
          &:hover
            margin-top -10px
          &.select-item-notebook
            margin-left 252px
          .select-item-title
            font-size 16px
    &.animate
      .select-bottom
        height $login-height * 0.558
        animation animate .5s ease-in
@keyframes animate
  0%
    height 0
  100%
    hight $login-height * 0.558
</style>



// WEBPACK FOOTER //
// src/components/Login.vue